import http from './http.json'

export default {
  http,
}
